import { all, fork } from 'redux-saga/effects';
import { publishTermsSagas } from './sagas/publishTerms';
import { betPositionSagas } from './sagas/betPosition';
import { fairPlaySagas } from './sagas/fairPlay';
import { checkoutInfoSagas } from './sagas/checkoutInfo';
import { topBetsSagas } from './sagas/topBets';
import { offerSagas } from './sagas/offer';
import { auctionSagas } from './sagas/auction';
import { publishInfoSagas } from './sagas/publishInfo';

export function* rootSaga() {
  yield all([
    publishTermsSagas,
    betPositionSagas,
    fairPlaySagas,
    checkoutInfoSagas,
    topBetsSagas,
    offerSagas,
    auctionSagas,
    publishInfoSagas,
  ].map(fork));
}
